import { plasticContainers } from "./plasticContainers.js";
import { cups } from "./cups.js";
import { aluminum } from "./aluminum.js";
import { sugarcane } from "./sugarcane.js";
import { bags } from "./bags.js";
import { misc } from "./misc.js";
import plasticContainersImage from "../assets/categories/plastic-containers.svg";
import cupsImage from "../assets/categories/cups.svg";
import aluminumImage from "../assets/categories/aluminum.svg";
import sugarcaneImage from "../assets/categories/sugarcane.svg";
import bagsImage from "../assets/categories/bags.svg";
import miscImage from "../assets/categories/misc.svg";

export const categories = [
  { slug: "plastic-containers", name: "Plastic Containers", description: "Plastic food and takeout containers for restaurants and food-service businesses.", image: plasticContainersImage, products: plasticContainers },
  { slug: "cups", name: "Cups", description: "Hot and cold drink cups, lids, straws, and cup accessories.", image: cupsImage, products: cups },
  { slug: "aluminum", name: "Aluminum", description: "Aluminum pans and matching lids for takeout, catering, and food preparation.", image: aluminumImage, products: aluminum },
  { slug: "sugarcane", name: "Sugarcane", description: "Compostable sugarcane plates, bowls, and hinged takeout containers.", image: sugarcaneImage, products: sugarcane },
  { slug: "bags", name: "Bags", description: "Paper, plastic, reusable carryout bags, and commercial trash bags.", image: bagsImage, products: bags },
  { slug: "misc", name: "Miscellaneous Supplies", description: "Cutlery, napkins, receipt paper, foil, film, and gloves.", image: miscImage, products: misc },
];

export const categoryBySlug = Object.fromEntries(categories.map((category) => [category.slug, category]));
